<template>
    <div>`
        <div class="top_box">
            <div class="top_tab">
                <span class="fl">高校后勤服务平台</span>
                <a class="fr cp"
                   target="_blank"
                   href="http://new.houqinbao.com">
                    <span>管理员登录</span>
                </a>
            </div>

            <div class="banner_box">
                <img class="logo"
                     :src="config.hallLogo"
                     alt="logo">
                <p class="school_name">{{config.hallTitle}}</p>
            </div>
            <div class="tab">
                <router-link class="route"
                             tag='span'
                             v-if="config.menuInfo && config.menuInfo.homeIndex == 1"
                             :to="{name: 'home', params: { schoolcode: Cookies.get('SCHOOLCODE')}}">平台首页</router-link>
                <router-link class="route"
                             v-if="config.menuInfo && config.menuInfo.dateSelect == 1"
                             tag='span'
                             :to="{name: 'searchData', params: { schoolcode: Cookies.get('SCHOOLCODE')}}">数据查询</router-link>
                <router-link class="route"
                             v-if="config.menuInfo && config.menuInfo.typeStatisticStause == 1"
                             tag='span'
                             :to="{name: 'statistics', params: { schoolcode: Cookies.get('SCHOOLCODE')}}">分类统计</router-link>
                <router-link class="route"
                             v-if="config.menuInfo && config.menuInfo.statisticRankingStause == 1"
                             tag='span'
                             :to="{name: 'rank', params: { schoolcode: Cookies.get('SCHOOLCODE')}}">统计排行</router-link>
                <div class="setMsg"
                     @click="$router.push({name: 'form'})">
                    <i></i>
                    <span>我要留言</span>
                </div>
            </div>
        </div>
        <div class="main_box">
            <router-view />
        </div>
        <div class="bottom_box">
            智慧后勤管理系统-服务监督大厅 版本号：v2.6.3 版本时间：2019.09
        </div>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import Cookies from "js-cookie";
export default {
    computed: {
        ...mapGetters(["config", "msgType"])
    },
    data() {
        return { Cookies };
    },
    created() {},
    methods: {}
};
</script>
<style lang="scss">
.top_box {
    width: 100%;
    height: 220px;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;

    .top_tab {
        width: 100%;
        height: 40px;
        background-color: #002140;
        color: #fff;
        line-height: 40px;
        span {
            margin-left: 26px;
            margin-right: 26px;
            display: flex;
            align-items: center;
        }

        i {
            margin-right: 6px;
            background: url("../assets/login.png") no-repeat center center;
            display: inline-block;
            width: 18px;
            height: 18px;
        }
        .fr {
            padding-left: 20px;
            background: url("../assets/per.png") no-repeat 25px 10px;
            background-size: 18px;
            color: #fff;
        }
    }

    .banner_box {
        width: 100%;
        height: 180px;
        background: url("../assets/banner.png") no-repeat center center;
        background-size: cover;
        display: flex;
        align-items: center;

        .logo {
            width: 112px;
            height: 112px;
            margin-left: 42px;
            border-radius: 50%;
        }

        .school_name {
            font-size: 34px;
            font-weight: 700;
            text-indent: 30px;
            letter-spacing: 4px;
            color: #fff;
        }
    }

    .tab {
        width: 1080px;
        height: 40px;
        border-radius: 5px;
        background-color: #3686e3;
        position: absolute;
        bottom: -20px;
        left: 50%;
        transform: translateX(-50%);
        display: flex;
        align-items: center;
        padding-left: 44px;

        .route {
            cursor: pointer;
            color: #fff;
            margin-right: 57px;
            height: 38px;
            width: 60px;
            text-align: center;
            line-height: 38px;
        }
        .router-link-active {
            border-bottom: 3px solid #ffaa16;
        }

        .setMsg {
            margin-left: auto;
            width: 130px;
            height: 40px;
            background-color: #2761e0;
            border-radius: 0 5px 5px 0;
            color: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;

            i {
                background: url("../assets/setMsg.png") no-repeat center center;
                width: 18px;
                height: 18px;
                margin-right: 12px;
            }
        }
    }
}

.main_box {
    width: 1098px;
    margin: 0 auto;
    padding-top: 270px;
}

.bottom_box {
    width: 100%;
    height: 50px;
    background: rgba(0, 33, 64, 1);
    text-align: center;
    line-height: 50px;
    color: #646e79;
    font-size: 14px;
}
</style>